import React, { useCallback, useEffect, useState } from "react";
import TitleHeaderPage from "../../components/infulancerComponent/TitleHeaderPage";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { MdAdd } from "react-icons/md";
import { Button, Col, Form, Row } from "react-bootstrap";
import { COLOR_APP } from "../../constants";
import ListInfulancer from "./ListInfulancer";
import InfulancerForm from "./component/InfulancerForm";
import {
  DELETE_COMMISION_INFLUENCER,
  GET_INFLUECERS,
  GET_SHOP_COMMISION_INFLUENCER,
} from "../../graphql/influencer/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import ModalConfirmComponent from "../../components/ModalConfirmComponent";
import { useToasts } from "react-toast-notifications";
import moment from "moment";
import _ from "lodash";
import useWindowDimensions from "../../helpers/useWindowDimensions";

function InfulancerListPage() {
  const [showInfulancer, setInfulancer] = useState({
    show: false,
    editMode: false,
    data: null,
    index: null,
  });
  const { addToast } = useToasts();
  const { height, width } = useWindowDimensions();


  const [dataCommission, setGetDataCommission] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [getIdDelete, setGetIdDelete] = useState();

  const handleCloseModalConfirm = () => setShowDelete(false);
  const handleOpenModalConfirm = (data) => {
    setGetIdDelete(data);
    setShowDelete(true);
  };
  const [filter, setFilter] = useState({});

  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

  // console.log('shopId9999----->', shopId)
  
  const [influencerData, { data: influData }] = useLazyQuery(GET_INFLUECERS, {
    fetchPolicy: "cache-and-network",
  });
  const [
    getCommisionInfluencer,
    { data: commisionInfluencer, loading: loadingCommision },
  ] = useLazyQuery(GET_SHOP_COMMISION_INFLUENCER, {
    fetchPolicy: "cache-and-network",
  });
  const [deleteCommissionInflue, { loading: deleteLoading }] = useMutation(
    DELETE_COMMISION_INFLUENCER
  );

  // console.log('commisionInfluencer----->', commisionInfluencer)

  const rowsPerPage = 30;
  const [page, setPage] = useState(0);
  const pageAll =
    commisionInfluencer?.shopSettingCommissions?.total > 0
      ? Math.ceil(
          commisionInfluencer?.shopSettingCommissions?.total / rowsPerPage
        )
      : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  useEffect(() => {
    influencerData({
      variables: {
        where: {
          // status: 'ACTIVE',
          // status_kyc:'APPROVED',
          // infulancer_kyc: true,
          isDeleted: false
        },
        orderBy: "createdAt_DESC",
        // limit: ,
        // skip: null,
      },
    });
  }, []);

  useEffect(() => {
    fetchcommissionData();
  }, [shopId]);

  const fetchcommissionData = () => {
    getCommisionInfluencer({
      variables: {
        where: {
          shop: shopId,
        },
        orderBy: "createdAt_DESC",
        limit: rowsPerPage,
        skip: page * rowsPerPage,
      },
    });
  };

  // filter data
  useEffect(() => {
    let _where = {
      shop: shopId,
    };

    if (!_.isEmpty(filter?.searchText)) {
      _where = {
        ..._where,
        shop_name: filter?.searchText,
        //  OR: [{ cfName: filter?.searchText }, { code: filter?.searchText }, {customerName: filter?.searchText}],
      };
    }

    if (
      !_.isEmpty(filter?.currentStartDate) &&
      !_.isEmpty(filter?.currentEndDate)
    ) {
      _where = {
        ..._where,
        createdAt_gte: new Date(
          moment(
            moment(filter?.currentStartDate).format("YYYY-MM-DD")
          ).toISOString()
        ),
        createdAt_lt: new Date(
          moment(moment(filter?.currentEndDate).add(1, "days")).format(
            "YYYY-MM-DD"
          )
        ).toISOString(),
      };
    }

    getCommisionInfluencer({
      variables: {
        where: _where,
        limit: rowsPerPage,
        skip: page * rowsPerPage,
        orderBy: "createdAt_DESC",
      },
    });
  }, [
    shopId,
    filter?.searchText,
    filter?.currentStartDate,
    filter?.currentEndDate,
    page,
  ]);

  // delete commission for influencer user
  const handleDeleteCommission = async () => {
    try {
      if (deleteLoading) return;

      const resDelete = await deleteCommissionInflue({
        variables: {
          where: {
            id: getIdDelete?.id,
          },
        },
      });
      if (resDelete?.data?.deleteShopSettingCommissionInfulancer?.id) {
        fetchcommissionData();
        setShowDelete(false);
        addToast("ລົບຂໍ້ມູນສຳລັດແລ້ວ", {
          appearance: "success",
          autoDismiss: true,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div>
      {/* header page */}
      <TitleHeaderPage
        title={"ຈັດການຄ່າຄອມມິດຊັ່ນ ອາຟຣິລີເອດ"}
        detail={"ໃຊ້ສຳລັບກຳນົດຄ່າຄອມມິດຊັ່ນສະເພາະບຸນຄົນ"}
        icon={faLink}
      />
      {/* header page */}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}>
        {width > 700 && <h3 style={{ color: "#616161" }}>ລາຍກາອາຟຣິລີເອດທີ່ໄດ້ ຄ່າຄອມ</h3>}
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            gap: "1em",
          }}>
          <Button
            onClick={() => {
              setInfulancer({ ...showInfulancer, show: true });
            }}
            style={{ background: COLOR_APP }}>
            <MdAdd style={{ fontSize: 23 }} />
            &nbsp; ກຳນົດຄ່າຄອມມິດຊັ່ນ
          </Button>
        </div>
      </div>

      <div className="pt-4 p-2 w-100 h-20">
        <Row>
          <Col xs={6}>
            <Form.Group className="mb-3">
              <Form.Label>ຄົ້ນຫາຊື່ ອາຟຣິລີເອດ</Form.Label>
              <Form.Control
                onChange={(e) => {
                  setFilter({ ...filter, searchText: e.target.value });
                }}
                value={filter?.searchText}
                type="text"
                placeholder="ປ້ອນຊື່ ອາຟຣິລີເອດ"
              />
            </Form.Group>
          </Col>
          <Col xs={3}>
            <Form.Group className="mb-3">
              <Form.Label>ວັນທີ</Form.Label>
              <Form.Control
                value={filter?.currentStartDate}
                onChange={(e) =>
                  setFilter({ ...filter, currentStartDate: e?.target?.value })
                }
                type="date"
              />
            </Form.Group>
          </Col>
          <Col xs={3}>
            <Form.Group className="mb-3">
              <Form.Label>ຫາ ວັນທີ</Form.Label>
              <Form.Control
                value={filter?.currentEndDate}
                onChange={(e) =>
                  setFilter({ ...filter, currentEndDate: e?.target?.value })
                }
                type="date"
              />
            </Form.Group>
          </Col>
        </Row>
      </div>

      {/* show list infulancer */}
      <ListInfulancer
        pageAll={pageAll}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        loadingCommision={loadingCommision}
        commisionInfluencer={commisionInfluencer?.shopSettingCommissionInfulancers?.data}
        commissionTotal={commisionInfluencer?.shopSettingCommissionInfulancers?.total}
        setGetDataCommission={setGetDataCommission}
        setInfulancer={setInfulancer}
        handleOpenModalConfirm={handleOpenModalConfirm}
      />

      {/* show form */}
      <InfulancerForm
        fetchcommissionData={fetchcommissionData}
        showForm={showInfulancer}
        shopId={shopId}
        dataCommission={dataCommission}
        hanldeClose={() =>
          setInfulancer({
            show: false,
            data: null,
            editMode: false,
            index: null,
          })
        }
        inFluData={influData?.infulancers}
      />

      {/* modal confirm component */}
      <ModalConfirmComponent
        showConfirmModal={showDelete}
        handleCancel={handleCloseModalConfirm}
        handleConfirm={handleDeleteCommission}
        title="ແຈ້ງເຕືອນ"
        text={`ຕ້ອງການລົບຄ່າຄອມມິດຊັ່ນຂອງ ${getIdDelete?.shop_name} ອອກແທ້ບໍ!`}
      />
    </div>
  );
}

export default InfulancerListPage;
